<template>
  <div class="title">
    全球领先的安全与速度体验
  </div>
  <div style="height: 2rem;"></div>
  <div class="desc">
    {{appName}}采用军事级加密技术，配备全球顶级服务器网络，提供业界最快的连接速度和最高级别的隐私保护。无论是4K视频流畅播放、零延迟游戏体验，还是绝对安全的数据传输，我们都是您的首选。
  </div>
</template>

<script>

  export default {
    name: 'WhyNeed',
    components: {},
  }
</script>

<style scoped>
  div {
    padding: 0 5%;
  }

  .title {
    text-align: center;
    font-weight: 800;
    font-size: 2.8rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1.3;
    letter-spacing: -0.5px;
    margin-bottom: 1.5rem;
  }

  .desc {
    color: #4a5568;
    font-size: 1.15rem;
    line-height: 1.8;
    max-width: 800px;
    margin: 0 auto;
    font-weight: 400;
    text-align: center;
  }

  @media all and (max-width: 799px) {
    .title {
      font-size: 2rem;
      letter-spacing: -0.3px;
    }
    .desc {
      font-size: 1.05rem;
      line-height: 1.7;
    }
  }
</style>
